var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthPlusSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "181.45 92.36 122.95 92.36 122.95 33.86 91.95 33.86 91.95 92.36 33.45 92.36 33.45 123.36 91.95 123.36 91.95 181.86 122.95 181.86 122.95 123.36 181.45 123.36 181.45 92.36"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthPlusSign);
export default __webpack_public_path__ + "static/media/HEALTH_PLUS_SIGN.2e388ed7fe96f8013bc5853313c08c5b.svg";
export { ForwardRef as ReactComponent };